import React from 'react';
import { cn, normalizeKey } from '@/lib/utils';
// import Link from 'next/link';
import { Badge } from '@/components/ui/badge';

interface TopicData {
  topic?: string;
}

interface MarketInsightsSummaryProps {
  summary: {
    showDate?: boolean;
    showAuthor?: boolean;
    showReviewer?: boolean;
    showTopics?: boolean;
  }
  data?: {
    date?: string;
    author?: string;
    reviewer?: string;
    topics?: TopicData[];
  }
}

export const MarketInsightsSummary = ({ 
    summary,
    data,
}: MarketInsightsSummaryProps) => {
  const innerSectionClass = cn(
    'rounded-xl py-6 border gap-5 flex flex-col',
  );
  const blockClass = cn(
    'flex flex-col gap-1 px-4',
  );
  const titleClass = cn(
    'paragraph-sm text-foreground font-bold',
  );
  const contentClass = cn(
    'paragraph-sm text-foreground',
  );
  const listItemClass = cn(
    'flex flex-col gap-1',
  );

  const formattedDate = new Date(data?.date ?? '').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <div className={innerSectionClass}>
      {summary.showDate && data?.date && (
        <div className={blockClass}>
          <div className={titleClass}>
            Date
          </div>
        <div className={contentClass}>
            {formattedDate}
          </div>
        </div>
      )}
      {summary.showAuthor && data?.author && (
        <div className={blockClass}>
          <div className={titleClass}>
            Written by
          </div>
          <div className={contentClass}>
            {data?.author}
          </div>
        </div>
      )}
      {summary.showReviewer && data?.reviewer && (
        <div className={blockClass}>
          <div className={titleClass}>
            Reviewed by
          </div>  
          <div className={contentClass}>
            {data?.reviewer}
          </div>
        </div>
      )}
      {summary.showTopics && data?.topics && (
        <div className={blockClass}>
          <div className={titleClass}>
            Topics
          </div>
          <div className={listItemClass}>
            {data?.topics?.map((topic) => (
              <Badge key={normalizeKey(topic.topic ?? '')} variant="secondary">
                {/* <Link key={normalizeKey(topic.topic ?? '')} href={`/resources/market-insights/?topic=${topic.topic}`}> */}
                  {topic.topic}
                {/* </Link> */}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}; 
